import React from 'react';
import {
  TextField as TPATextField,
  TextFieldTheme,
} from 'wix-ui-tpa/TextField';
import { Text, TYPOGRAPHY } from 'wix-ui-tpa/Text';
import { TextFieldProps } from '../../../../types/AdaptedComponents';
import { DeviceType } from '@wix/cashier-common/dist/src/enums/DeviceType';
import { Theme } from '../../../../types/Theme';
import { DH } from '../../../../utils/DataHook';
import { UILibrary } from '../../../../types/UILibrary';
import { experimentsService } from '@wix/cashier-common/dist/src/utils/experimentsService';
import { Experiment } from '../../../../types/Experiment';

export const TextField: React.FC<TextFieldProps> = (props) => {
  const { deviceType = DeviceType.Desktop, type = 'text' } = props;
  const inputTheme =
    deviceType === DeviceType.Desktop
      ? TextFieldTheme.Box
      : TextFieldTheme.Line;
  const withAsterisk = props.required && props.theme !== Theme.modal;

  return (
    <div
      data-hook={DH.PaymentDetails.TextField.Container}
      data-ui-lib={'tpa' as UILibrary}
    >
      <label htmlFor={props.name}>
        <Text
          data-hook={DH.PaymentDetails.TextField.Label}
          typography={TYPOGRAPHY.listText}
        >
          {experimentsService.isExperimentEnabled(
            Experiment.AsteriskAfterText
          ) ? (
            <>
              {props.label}
              {withAsterisk && (
                <span data-hook={DH.PaymentDetails.TextField.Asterisk}> *</span>
              )}
            </>
          ) : (
            <>
              {withAsterisk && (
                <span data-hook={DH.PaymentDetails.TextField.Asterisk}>* </span>
              )}
              {props.label}
            </>
          )}
        </Text>
      </label>

      <TPATextField
        data-hook={DH.PaymentDetails.TextField.Input(props.name)}
        value={props.value}
        name={props.name}
        id={props.name}
        theme={inputTheme}
        onChange={props.onChange}
        onBlur={props.onBlur}
        error={!!props.errorMessage}
        errorMessage={props.errorMessage}
        type={type}
        placeholder={props.placeholder}
        aria-label={props.label}
        aria-required={props.required}
        aria-invalid={!!props.errorMessage}
        aria-errormessage={props.errorMessage}
        aria-placeholder={props.placeholder}
        // @ts-ignore
        ref={props.inputRef}
      />
    </div>
  );
};
TextField.displayName = 'TextField';
